import { PageViewPayload } from '@/js/pages/helpers/tracking-script/types';

export const pv = async (payload: PageViewPayload): Promise<void> => {
    const trackerBaseUrl = import.meta.env.VITE_VULPR_BASE_URL;

    if (!trackerBaseUrl) {
        return;
    }

    const api = `${trackerBaseUrl}/api/v1/tr/pv`;

    await fetch(api, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
        keepalive: true,
        credentials: 'omit',
        mode: 'cors',
    });
};
